export const DEFAULT_MATERIAL_TYPE_CODE = "Tires";

export const MAX_QUANTITY = 99999;
export const MAX_COMMENT_LENGTH = 200;
export const MAX_PRIORITY_REASON_LENGTH = 200;

export const getDefaultMaterialCode = (
  materialTypes: { code: string }[],
  defaultCode: string
): string | null =>
  materialTypes.find((type) => type.code === defaultCode)?.code ??
  materialTypes[0]?.code ??
  null;
